// extracted by mini-css-extract-plugin
export default {"Catalog":"Catalog_Catalog__r1uGG"};